import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ngx-footer-actions',
  templateUrl: './footer-actions.component.html',
  styleUrls: ['./footer-actions.component.scss'],
})
export class FooterActionsComponent {

  @Input() disableButtonContinuar: boolean;
  @Output() cancelAction = new EventEmitter<void>();
  @Output() continueAction = new EventEmitter<void>();
  @Input() titleButtonCancelar: string = 'CANCELAR';
  @Input() titleButtonContinuar: string = 'CONTINUAR';
  @Input() showButtonContinuar: boolean = true;
  @Input() showButtonCancelar: boolean = true;

  customLogin = null;

  cancel() {
    this.cancelAction.emit();
  }

  continue() {
    this.continueAction.emit();
  }
}
